import * as React from 'react';
import { isServer } from '../config/utils.esm.js';

var NucleobaseEngineContext = React.createContext(null);
var useNucleobaseEngine = function (props) {
    var nucleobaseEngineContext = React.useContext(NucleobaseEngineContext);
    if (!nucleobaseEngineContext && isServer()) {
        return null; // the nucleobaseEngineContext is lost during SSR but is available on the client
    }
    else if (!nucleobaseEngineContext) {
        throw Error('Provide Engine Config');
    }
    return nucleobaseEngineContext.useEngine(props);
};

export { NucleobaseEngineContext, useNucleobaseEngine };
//# sourceMappingURL=NucleobaseEngineContext.esm.js.map
